import { $_DKD, $_GCD, $_CD, $_TYPE } from '@/confs/common.const.js';
import commonApi from "@/apis/common.api.js";
import gripUtil from "@/libs/grip.util";

export default {
    state: {
        iconMap: {
            1: 'icon01', 2: 'icon02', 3: 'icon04', 4: 'icon03',
            5: 'icon05', 6: 'icon06', 7: 'icon08', 8: 'icon07',
        },
        indicatorCateList: [],
        indicatorIdxList: [],
        indicatorDataKdMap: {},
        indicatorDataMap: {},
        indicatorDataKdHdngMap: {},
        indicatorLatestedIdxList: [],
        indicatorLatestedDataKdMap: {},
        indicatorLatestedDataMap: {},
        indicatorLatestedDataKdHdngMap: {},
        selectedIndicatorCate: '',
        indicatorIdxCateMap: {},
        clazzMap: {
            1: 'R', 2:'B', 3:'N',4:'G',5:'V',6:'O',7:'OO',8:'Y',
        },
        selectedIndicator: {},
        selectedIndicator2: {},
        isDetail: false,

        selectedIndicatorList: [],
        selectedIndicatorDataKdMap: {},
        selectedIndicatorDataMap: {},
        selectedIndicatorDataKdHdngMap: {},
        selectedIndicatorMap: {},
        idxSqnoParam: '',

        includedFilterList: [83, 181],
        chartParamMap: {
            141:'080',
            163:'900',
            183:'110',
            201:'010',
            202:'070',
            203:'140',
            204:'120',
            205:'060',
            206:'050',
            207:'090',
            208:'020',
            209:'160',
            210:'100',
        },
    },
    getters: {
        getIconMap(state) {
            return state.iconMap;
        },
        getIndicatorCateList(state) {
            return state.indicatorCateList;
        },
        getIndicatorIdxList(state) {
            return state.indicatorIdxList;
        },
        getIndicatorDataKdMap(state) {
            return state.indicatorDataKdMap;
        },
        getIndicatorDataMap(state) {
            return state.indicatorDataMap;
        },
        getIndicatorDataKdHdngMap(state) {
            return state.indicatorDataKdHdngMap;
        },

        getIndicatorLatestedIdxList(state) {
            return state.indicatorLatestedIdxList;
        },
        getIndicatorLatestedDataKdMap(state) {
            return state.indicatorLatestedDataKdMap;
        },
        getIndicatorLatestedDataMap(state) {
            return state.indicatorLatestedDataMap;
        },
        getIndicatorLatestedDataKdHdngMap(state) {
            return state.indicatorLatestedDataKdHdngMap;
        },

        getSelectedIndicatorCate(state) {
            return state.selectedIndicatorCate;
        },
        getIndicatorIdxCateMap(state) {
            return state.indicatorIdxCateMap;
        },
        getClazzMap(state) {
            return state.clazzMap;
        },
        getSelectedIndicator(state) {
            return state.selectedIndicator;
        },
        getSelectedIndicator2(state) {
            return state.selectedIndicator2;
        },
        getIsDetail(state) {
            return state.isDetail;
        },
        getSelectedIndicatorList(state) {
            return state.selectedIndicatorList;
        },
        getSelectedIndicatorDataKdMap(state) {
            return state.selectedIndicatorDataKdMap;
        },
        getSelectedIndicatorDataMap(state) {
            return state.selectedIndicatorDataMap;
        },
        getSelectedIndicatorDataKdHdngMap(state) {
            return state.selectedIndicatorDataKdHdngMap;
        },
        getSelectedIndicatorMap(state) {
            return state.selectedIndicatorMap;
        },
        getIdxSqnoParam(state) {
            return state.idxSqnoParam;
        },
        getIncludedFilterList(state) {
            return state.includedFilterList;
        },
        getChartParamMap(state) {
            return state.chartParamMap;
        },
    },
    mutations: {
        INDICATOR_CATE_LIST(state, indicatorCateList) {
            state.indicatorCateList = indicatorCateList;
        },
        INDICATOR_IDX_LIST(state, indicatorIdxList) {
            state.indicatorIdxList = indicatorIdxList;
        },
        INDICATOR_DATA_KD_MAP(state, indicatorDataKdMap) {
            state.indicatorDataKdMap = indicatorDataKdMap;
        },
        INDICATOR_DATA_MAP(state, indicatorDataMap) {
            state.indicatorDataMap = indicatorDataMap;
        },
        INDICATOR_COL_MAP(state, indicatorDataKdHdngMap) {
            state.indicatorDataKdHdngMap = indicatorDataKdHdngMap;
        },

        INDICATOR_LATESTED_IDX_LIST(state, indicatorLatestedIdxList) {
            state.indicatorLatestedIdxList = indicatorLatestedIdxList;
        },
        INDICATOR_LATESTED_DATA_KD_MAP(state, indicatorLatestedDataKdMap) {
            state.indicatorLatestedDataKdMap = indicatorLatestedDataKdMap;
        },
        INDICATOR_LATESTED_DATA_MAP(state, indicatorLatestedDataMap) {
            state.indicatorLatestedDataMap = indicatorLatestedDataMap;
        },
        INDICATOR_LATESTED_COL_MAP(state, indicatorLatestedDataKdHdngMap) {
            state.indicatorLatestedDataKdHdngMap = indicatorLatestedDataKdHdngMap;
        },

        SELECTED_INDICATOR_CATE(state, selectedIndicatorCate) {
            state.selectedIndicatorCate = selectedIndicatorCate;
        },
        INDICATOR_IDX_CATE_MAP(state, indicatorIdxCateMap) {
            state.indicatorIdxCateMap = indicatorIdxCateMap;
        },
        SELECTED_INDICATOR(state, selectedIndicator) {
            state.selectedIndicator = selectedIndicator;
        },
        SELECTED_INDICATOR2(state, selectedIndicator2) {
            state.selectedIndicator2 = selectedIndicator2;
        },
        IS_DETAIL(state, isDetail) {
            state.isDetail = isDetail;
        },

        SELECTED_INDICATOR_LIST(state, selectedIndicatorList) {
            state.selectedIndicatorList = selectedIndicatorList;
        },

        SELECTED_INDICATOR_DATA_KD_MAP(state, selectedIndicatorDataKdMap) {
            state.selectedIndicatorDataKdMap = selectedIndicatorDataKdMap;
        },

        SELECTED_INDICATOR_DATA_MAP(state, selectedIndicatorDataMap) {
            state.selectedIndicatorDataMap = selectedIndicatorDataMap;
        },

        SELECTED_INDICATOR_DATA_KD_HDNG_MAP(state, selectedIndicatorDataKdHdngMap) {
            state.selectedIndicatorDataKdHdngMap = selectedIndicatorDataKdHdngMap;
        },
        SELECTED_INDICATOR_MAP(state, selectedIndicatorMap) {
            state.selectedIndicatorMap = selectedIndicatorMap;
        },

        IDX_SQNO_PARAM(state, idxSqnoParam) {
            state.idxSqnoParam = idxSqnoParam;
        },
    },
    actions : {
        FETCH_INDICATOR_CATE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_CD.INDICATOR_CATEGORY)
                .then(function(res) {
                    commit("INDICATOR_CATE_LIST", res.data.data);
                });
        },

        FETCH_INDICATOR_LATESTED_IDX_LIST({commit}, q) {
            return commonApi.fetchReposByDataLatestedIdxList(q)
                .then(res=>{
                    commit("INDICATOR_LATESTED_IDX_LIST", res.data.data.idxList);
                    commit('INDICATOR_LATESTED_DATA_KD_MAP', res.data.data.dataKdMap);
                    commit('INDICATOR_LATESTED_DATA_MAP', res.data.data.dataMap);
                    commit('INDICATOR_LATESTED_COL_MAP', res.data.data.dataKdHdngMap);
                });
        },
        FETCH_INDICATOR_IDX_LIST({commit}, q) {
            let filterList = this.getters.getIncludedFilterList;
            return commonApi.fetchReposByDataIdxList(q)
                .then(function(res) {
                    let idxList = [];

                    idxList = res.data.data.idxList.filter((d) => {
                        if(!filterList.includes(d.idxSqno)) {
                            if(d.openYn == '1') {
                                return true;
                            }
                        }
                    });

                    idxList.sort(function(pre, cur) {
                        return Number(pre.idxDispSq) > Number(cur.idxDispSq) ? 1 : Number(pre.idxDispSq) < Number(cur.idxDispSq) ? -1 : 0;
                    });

                    commit("INDICATOR_IDX_LIST", idxList);
                    commit('INDICATOR_IDX_CATE_MAP', gripUtil.toMap(idxList,'idxCateCd'));
                    commit('INDICATOR_DATA_KD_MAP', res.data.data.dataKdMap);
                    commit('INDICATOR_DATA_MAP', res.data.data.dataMap);
                    commit('INDICATOR_COL_MAP', res.data.data.dataKdHdngMap);
                });
        },
        FETCH_SELECTED_INDICATOR_IDX_LIST({commit}, q) {
            let code = q.split('searchKeyword=')[1];
            let indicatorMap = this.getters.getSelectedIndicatorMap;
            let filterList = this.getters.getIncludedFilterList;
            if(typeof indicatorMap[code] === $_TYPE.UNDEF) {
                return commonApi.fetchReposByDataIdxList(q)
                    .then(function(res) {
                        let idxList = [];

                        idxList = res.data.data.idxList.filter((d) => {
                            if(d.openYn == '1') {
                                return true;
                            }
                        });

                        idxList.sort(function(pre, cur) {
                            return Number(pre.idxDispSq) > Number(cur.idxDispSq) ? 1 : Number(pre.idxDispSq) < Number(cur.idxDispSq) ? -1 : 0;
                        });
                        let map = {
                            idxList: [],
                            dataMap: {},
                            dataKdMap: {},
                            hdngMap: {},
                        }
                        commit("SELECTED_INDICATOR_LIST", idxList);
                        commit('SELECTED_INDICATOR_DATA_KD_MAP', res.data.data.dataKdMap);
                        commit('SELECTED_INDICATOR_DATA_MAP', res.data.data.dataMap);
                        commit('SELECTED_INDICATOR_DATA_KD_HDNG_MAP', res.data.data.dataKdHdngMap);
                        map.idxList = idxList;
                        map.dataMap = res.data.data.dataMap;
                        map.dataKdMap = res.data.data.dataKdMap;
                        map.hdngMap = res.data.data.dataKdHdngMap;
                        indicatorMap[code] = map;

                        commit("SELECTED_INDICATOR_MAP", indicatorMap);
                    });

            }
        },
        SET_SELECTED_INDICATOR_CATE({commit}, selectedIndicatorCate) {
            commit("SELECTED_INDICATOR_CATE", selectedIndicatorCate);
        },
        SET_SELECTED_INDICATOR({commit}, selectedIndicator) {
            commit("SELECTED_INDICATOR", selectedIndicator);
        },
        SET_SELECTED_INDICATOR2({commit}, selectedIndicator2) {
            commit("SELECTED_INDICATOR2", selectedIndicator2);
        },
        SET_IS_DETAIL({commit}, isDetail) {
            commit("IS_DETAIL", isDetail);
        },
        SET_IDX_SQNO_PARAM({commit}, idxSqnoParam) {
            commit("IDX_SQNO_PARAM", idxSqnoParam);
        }
    },
};
